import React from 'react'
import "./style.css"

function Loading({ color, border }) {
    return (
        <div
            className='loading'
            style={{
                '--_g': color ? `no-repeat radial-gradient(farthest-side, ${color} 94%, #0000)` : undefined, // Ajusta o gradiente se `color` for fornecido
                border: border ? `2px solid ${border}` : undefined, // Ajusta a borda se `border` for fornecido
            }}
        />

    )
}

export default Loading
